import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionStateService } from '../services/session/session-state.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly sessionState = inject(SessionStateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      withCredentials: true,
      setHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    return next.handle(authReq).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          if (!this.isAuthBootstrapRequest(req)) {
            this.sessionState.notifyExpired();
          }
        }
        return throwError(() => err);
      })
    );
  }

  // Login/signup/reset endpoints intentionally return 401/403 on bad credentials —
  // those should not be treated as session expiry.
  private isAuthBootstrapRequest(req: HttpRequest<any>): boolean {
    const url = req.url || '';
    return /\/api\/(authenticate|signup|resetPassword|logout)/.test(url);
  }
}
